import type {
  ArticleAttrs,
  ArticleLevel,
} from '@freckle/educator-entities/ts/ela/articles/models/article'
import {parseArticle} from '@freckle/educator-entities/ts/ela/articles/models/article'
import {getFirstArticleLevel} from '@freckle/classroom/ts/common/logic/article-description'
import {parseElaArticle} from '@freckle/classroom/ts/ela/debugger/logic/parser'

export type FileLoadedState = {
  article: ArticleAttrs
  fileInputValue: Blob
  currentArticleLevel: ArticleLevel
}

export type State = {tag: 'no-file-loaded'} | ({tag: 'file-loaded'} & FileLoadedState)

export function parseYamlFile(fileInputValue: Blob): Promise<FileLoadedState> {
  return new Promise(resolve => {
    const fileReader = new FileReader()
    fileReader.readAsText(fileInputValue)
    fileReader.onloadend = () => {
      const articleObj = parseElaArticle(fileReader.result)
      const article = parseArticle(articleObj)
      const currentArticleLevel = getFirstArticleLevel(article)
      resolve({
        article,
        fileInputValue,
        currentArticleLevel,
      })
    }
  })
}
